import { useContext } from "react"
import { useStaticQuery, graphql } from "gatsby"
import LocaleContext from "../localeContext"

export default () => {
  const { locale } = useContext(LocaleContext)
  const { rawData } = useStaticQuery(query)

  const simplified = rawData.edges.map(item => {
    return {
      name: item.node.name,
      translations: item.node.translations,
    }
  })

  const { translations } = simplified.filter(lang => lang.name === locale)[0]

  // console.log("heyo")

  return translations
}

const query = graphql`
  query useTranslations {
    rawData: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
      edges {
        node {
          name
          translations: childTranslationsJson {
            site_title
            nav_title_home
            nav_title_business
            nav_title_company
            nav_title_group
            nav_title_recruit
            nav_title_contact
            subnav_business_title_event
            subnav_business_title_inbound
            subnav_business_title_artists
            subnav_business_title_advertising
            subnav_business_title_clubs
            subnav_business_title_others
            subnav_business_description_event
            subnav_business_description_inbound
            subnav_business_description_artists
            subnav_business_description_advertising
            subnav_business_description_clubs
            subnav_business_description_others
            subnav_company_title_overview
            subnav_company_title_officers
            subnav_company_title_csr
            subnav_company_title_sdg
            subnav_company_title_history
            subnav_company_title_works
            subnav_company_description_overview
            subnav_company_description_officers
            subnav_company_description_csr
            subnav_company_description_sdg
            subnav_company_description_history
            subnav_company_description_works
            home_slide1_tagline
            home_slide1_heading
            home_slide1_body
            home_slide1_link_text
            home_slide2_tagline
            home_slide2_heading
            home_slide2_body
            home_slide2_link_text
            home_slide3_tagline
            home_slide3_heading
            home_slide3_body
            home_slide3_link_text
            home_slide4_tagline
            home_slide4_heading
            home_slide4_body
            home_slide4_link_text
          }
        }
      }
    }
  }
`
